import ErpNodepadList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/notepad") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpNodepadList();
    }
}